/* istanbul ignore file */

import { Session, Events } from "@collectivehealth/cog";

const SECONDS_BEFORE_TIMEOUT_TO_REFRESH = 120;
const MS_BEFORE_TIMEOUT_TO_REFRESH = SECONDS_BEFORE_TIMEOUT_TO_REFRESH * 1000;

export function minutesToMilliseconds(minutes) {
  return secondsToMilliseconds(minutes * 60);
}

export function secondsToMilliseconds(seconds) {
  return seconds * 1000;
}

export function keepalive() {
  const interval = setInterval(() => {
    if (Session.getSession().exp * 1000 - MS_BEFORE_TIMEOUT_TO_REFRESH <= Date.now()) {
      Session.extendSession();
    }
  }, secondsToMilliseconds(30));

  Events.on(Events.LOGOUT_EVENT, () => clearInterval(interval));
}
